import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Role, UserSettings } from '../../base/authentication/user';

export class SettingsFormGroup extends FormGroup<{
  language: FormControl<string | null>,
  opcoCode: FormControl<string | null>,
  depotId: FormControl<string | null>
}> {

  readonly isDepotRequired: boolean;

  constructor(settings: UserSettings, userRoles: Role[]) {
    super({
      language: new FormControl<string | null>(settings.language, [Validators.required]),
      opcoCode: new FormControl<string | null>(settings.opcoCode, [Validators.required]),
      depotId: new FormControl<string | null>(settings.depotId),
    });

    this.isDepotRequired = userRoles.includes(Role.HANDOVER);
    if (this.isDepotRequired) {
      this.controls.depotId.addValidators(Validators.required);
      this.controls.depotId.updateValueAndValidity();
    } else {
      this.controls.depotId.disable();
    }
  }

  toSettings() {
    return this.getRawValue() as UserSettings;
  }

  get language() {
    return this.controls.language;
  }

  get opco() {
    return this.controls.opcoCode;
  }

  get depot() {
    return this.controls.depotId;
  }
}
